import { requestAsync } from 'redux-query';
import { putResolve, select, takeLatest, call } from 'redux-saga/effects';
import { ActionArguments } from 'src/api/queries';
import { actions } from 'src/reducers/actions';
import { ComponentActionTypes } from 'src/reducers/components';

interface ActionPayload {
  payload: { actionUri: string };
}

export function* getActionArguments(actionUri: string) {
  const actionArguments = yield select(ActionArguments.selector);
  if (!actionArguments || !actionArguments.hasOwnProperty(actionUri)) {
    yield putResolve(requestAsync(ActionArguments.get(actionUri)));
  }
}

export function* actionResolve(action: ActionPayload) {
  const actionUri = action.payload?.actionUri;

  yield call(getActionArguments, actionUri);

  yield putResolve({
    type: ComponentActionTypes.TOGGLE_DISPLAY_COMPONENT,
    payload: { component: 'actionForm', props: { visible: true, actionUri } },
    meta: { source: 'SAGA_ACTION' },
  });
}

function* watchActionResolve() {
  yield takeLatest<any>(actions.action.DISPATCH_ACTION, actionResolve);
}

export default [watchActionResolve];
